import React, { useEffect, useState } from 'react';
import { CheckCircle } from 'lucide-react';
const PURCHASES = [{
  name: 'Jean-Marc L.',
  city: 'Lyon'
}, {
  name: 'Amélie D.',
  city: 'Paris'
}, {
  name: 'Marc R.',
  city: 'Marseille'
}, {
  name: 'Sophie B.',
  city: 'Bordeaux'
}, {
  name: 'Thomas P.',
  city: 'Toulouse'
}, {
  name: 'Camille V.',
  city: 'Nantes'
}, {
  name: 'Julien M.',
  city: 'Bruxelles'
}, {
  name: 'Laurent F.',
  city: 'Genève'
}, {
  name: 'Karine T.',
  city: 'Montréal'
}, {
  name: 'Nicolas G.',
  city: 'Strasbourg'
}];
export function PurchasePopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentPurchase, setCurrentPurchase] = useState(PURCHASES[0]);
  useEffect(() => {
    const initialTimeout = setTimeout(() => {
      showRandomPurchase();
    }, 5000);
    return () => clearTimeout(initialTimeout);
  }, []);
  const showRandomPurchase = () => {
    const randomPurchase = PURCHASES[Math.floor(Math.random() * PURCHASES.length)];
    setCurrentPurchase(randomPurchase);
    setIsVisible(true);
    setTimeout(() => {
      setIsVisible(false);
      const nextDelay = Math.floor(Math.random() * (15000 - 8000 + 1) + 8000);
      setTimeout(showRandomPurchase, nextDelay);
    }, 4000);
  };
  if (!isVisible) return null;
  return <div className="fixed bottom-4 left-4 z-50 animate-fade-in-up md:bottom-8 md:left-8" data-id="element-197">
      <div className="bg-white rounded-lg shadow-xl border-l-4 border-yellow-400 p-4 flex items-center max-w-xs md:max-w-sm" data-id="element-198">
        <div className="mr-4 bg-blue-100 rounded-full p-2" data-id="element-199">
          <CheckCircle className="h-6 w-6 text-blue-900" data-id="element-200" />
        </div>
        <div data-id="element-201">
          <p className="text-sm font-bold text-gray-900" data-id="element-202">
            {currentPurchase.name} vient d'acheter le Pack
          </p>
          <p className="text-xs text-gray-500" data-id="element-203">
            Depuis {currentPurchase.city} • Il y a un instant
          </p>
        </div>
      </div>
    </div>;
}